import { SortModel } from '../../models';
import { toggleSortModel } from './toggleSortModel';

/**
 * Creates a sort toggle handler that resets pagination
 */
export const createSortToggleHandler = (
  sortModel: SortModel[],
  setSortModel: (sortModel: SortModel[]) => void,
  setPage: (page: number) => void
) => {
  return (field: string, shiftKey: boolean) => {
    // Reset to beginning when sorting changes
    setPage(1);
    const newSort = toggleSortModel(sortModel, field, shiftKey);
    setSortModel(newSort);
  };
};
